let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kpnZo")).then(() => parcelRequire('aN7Ef'));